module.exports = __webpack_public_path__ + "static/media/abe-lol.9570e1f5.png";